import { render, staticRenderFns } from "./travaux-restants-confirmation.vue?vue&type=template&id=ec82ed5a&scoped=true"
import script from "./travaux-restants-confirmation.vue?vue&type=script&lang=ts"
export * from "./travaux-restants-confirmation.vue?vue&type=script&lang=ts"
import style0 from "./travaux-restants-confirmation.vue?vue&type=style&index=0&id=ec82ed5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec82ed5a",
  null
  
)

export default component.exports